<accept-confirm-modal-tag>
   <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
    .wp60 {
      width: 60%;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner" if={!props.sentJudge}>
        <h3 class="modal_heading margin-spacing-3_bottom">
          プロジェクトの受託
        </h3>

        <p class="modal_lead">
          受託意思がある旨をクライアント様に送信します
<p style="white-space: pre-wrap">
＜必ずご確認ください＞
・プロジェクトが確定するとキャンセルはできなくなります。
・プロジェクト確定後に報酬金額を変更することはできません。
・プロジェクトが確定すると、支払先情報の必要事項としてご登録の指名、住所が開示されます。
※プロジェクトの内容に不都合がある場合は、必ずチャットでの交渉や修正依頼をしてください。
</p>
        </p>




        <div class="wrap_button margin-spacing-2_top">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="いいえ"
            onclick="{ props.onClose }"
          >
            いいえ
          </div>
          <div
            class="button button-secondary-large"
            type="button"
            value="はい"
            onclick="{ onSubmit }"
          >
            この内容で受託する
          </div>
        </div>
      </div>
      <div class="modal__content_inner" if={props.sentJudge}>
        <h3 class="modal_heading margin-spacing-3_bottom">
          受託意思を送信しました
        </h3>

        <p class="modal_lead note">【ご注意ください】</p>
        <p class="modal_lead">
          クライアント様側でプロジェクトの契約を成立するための処理を行います。<br>
          こちらが終了するまで契約は成立していない状態になりますので、こちらが終了するまで
          案件の稼働はしないようにしてください。
        </p>
        <p class="modal_lead">
          <ul>
            <li>受託意思を送っても必ずしも契約が成立する訳ではありません</li>
            <li>クライアント様の都合により、公募を途中終了することがあります</li>
          </ul>
        </p>
        <div class="wrap_button margin-spacing-2_top">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="閉じる"
            onclick="{ props.onOk }"
          >
            閉じる
          </div>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      onSubmit(){
        this.props.onSubmit();
      }
    };
  </script>

</accept-confirm-modal-tag>
